import React, { useContext, useState } from "react"; //
import {
  //
  bearlog,
  BearDiv,
  BearList,
  BearBorder,
  BearLine,
} from "@sillyscribe95/bear-ui-web";
import { MainContext } from "../context/MainContext";
import { InstChoose } from "../components/InstChoose";
import { ChordGrid } from "./ChordGrid";
import { KeyArrows } from "./KeyArrows";

export function HomeMobile({ input }) {
  const {
    //
    isnSound,
    setisnSound,
    reffo,
    playChord,
    playKey,
    shiftpic,
    playMain,
    picho,
    playChordMain,
  } = useContext(MainContext);

  const [viewInt, setviewInt] = useState();

  const sirease = KeyArrows();
  const chordos = BearList({
    list: [1, 2, 3, 4, 5, 6, 7, 8],
    // list: [1, 2, 3, 4],
    bearName: " asdle",
    renderItem: ChordGrid,
  });

  const okfdsd = BearDiv({
    obj: (
      <>
        {/*  */}
        {sirease}
        {BearLine(10)}
        {chordos}
      </>
    ),
  });

  //   1config
  const oaskde = {
    // headerConfig:
  };

  const jsase = {
    center: InstChoose({
      //
      // onClick:
    }),
  };

  return { item: okfdsd, config: jsase };
}
